import React, {Fragment} from "react";

const Home = () => {
  return (
      <div className='page-content'>
          <div className='banner-section'>
              <div className='container'>
                  <div className='row'>
                      <div className='col-md-7 order-2 order-sm-2 order-md-1'>
                          <div className='banner-content wow animate__animated animate__fadeInLeft'>
                              <h1>
                                  Engineering <span className='text-primary'>Digital Excellence </span> Through <span
                                  className='text-primary'>AI & Automation</span>
                              </h1>
                              <p className='text-secondary text-capitalize'>
                                  Kosmic Lab delivers intelligent, future-ready technology solutions by integrating
                                  automation, cloud, and secure network infrastructure, empowering businesses to scale
                                  faster, optimize performance, and lead confidently in a digital-first world.
                              </p>
                              <div className='banner-btn-div sec-btn'>
                                  <a href='#' className='btn btn-dark'>Get in touch</a>
                                  <a href='#' className='btn btn-outline-dark'>
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                          <path
                                              d="M2.46094 20.6531C2.01562 21.0234 1.39219 21.1078 0.8625 20.8593C0.332812 20.6109 0 20.0812 0 19.5V4.49997C0 3.91872 0.3375 3.38903 0.8625 3.14059C1.3875 2.89215 2.01094 2.97184 2.46094 3.34684L10.5 10.0453V12V13.9547L2.46094 20.6531ZM12 16.5V12V5.99997V4.49997C12 3.91872 12.3375 3.38903 12.8625 3.14059C13.3875 2.89215 14.0109 2.97184 14.4609 3.34684L23.4609 10.8468C23.8031 11.1328 24 11.5547 24 12C24 12.4453 23.8031 12.8672 23.4609 13.1531L14.4609 20.6531C14.0156 21.0234 13.3922 21.1078 12.8625 20.8593C12.3328 20.6109 12 20.0812 12 19.5V16.5Z"
                                              fill="#F7690E"/>
                                      </svg>
                                      Book free demo
                                  </a>
                              </div>
                          </div>
                      </div>
                      <div className='col-md-5 text-center order-1 order-sm-1 order-md-2 mb-4 mb-sm-4 mb-md-0'>
                          <img
                              src="/assets/images/banner-img.png"
                              alt="Logo"
                              className="img-fluid wow animate__animated animate__fadeInRight"
                          />
                      </div>
                  </div>
              </div>
          </div>
          <div className='brand-section position-relative z-1 wow animate__animated animate__fadeInRight'>
              <div className='container'>
                  <div className='row'>
                      <div className='col-xl-7 offset-xl-5'>
                          <div className='brand-div'>
                              <h5>We’ve worked with 100+ globe brands.</h5>
                              <div className='brand-list'>
                                  <div className='brand-img'>
                                      <img
                                          src="/assets/images/brand-1.png"
                                          alt="brand"
                                          className="img-fluid"
                                      />
                                  </div>
                                  <div className='brand-img'>
                                      <img
                                          src="/assets/images/brand-2.png"
                                          alt="brand"
                                          className="img-fluid"
                                      />
                                  </div>
                                  <div className='brand-img'>
                                      <img
                                          src="/assets/images/brand-3.png"
                                          alt="brand"
                                          className="img-fluid"
                                      />
                                  </div>
                                  <div className='brand-img'>
                                      <img
                                          src="/assets/images/brand-4.png"
                                          alt="brand"
                                          className="img-fluid"
                                      />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className='about-section'>
              <div className='container'>
                  <div className='row align-items-end'>
                      <div className='col-md-5'>
                          <div
                              className='about-img position-relative mb-4 mb-ms-4 mb-md-0 wow animate__animated animate__fadeInUp'>
                              <img
                                  src="/assets/images/about-img.png"
                                  alt="img"
                                  className="img-fluid"
                              />
                          </div>
                      </div>
                      <div className='col-md-7'>
                          <div className='about-content-div text-white wow animate__animated animate__fadeInRight'>
                              <h1 className='mb-20'>
                                  About <span className='text-primary'>Kosmic Lab</span>
                              </h1>
                              <p className='mb-20'>
                                  At Kosmic Lab, we are driven by the belief that technology should not just support
                                  business—it should elevate it. As a forward-thinking IT solutions provider, we
                                  specialize in delivering intelligent, secure, and scalable services across cloud
                                  infrastructure, AI automation, network engineering, and cybersecurity. Our core
                                  mission is to help businesses seamlessly transition into the digital era through
                                  powerful tech ecosystems that are built for performance, reliability, and long-term
                                  growth.
                              </p>
                              <p className='mb-20'>
                                  With deep expertise in multi-cloud architecture, infrastructure automation,
                                  observability, and end-to-end network solutions, we partner with enterprises to
                                  simplify complexity and accelerate innovation. Whether it's deploying next-gen base
                                  stations, implementing secure cloud migrations, or enabling AI-driven business
                                  processes.
                              </p>
                              <div className='about-btn-div d-flex sec-btn'>
                                  <a href='#' className='btn btn-outline-light'>Learn more about us</a>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          {/*<div className='product-section bg-black'>
              <div className='container'>
                  <div className='row justify-content-center'>
                      <div className='col-md-10'>
                          <div className='section-title-div text-center wow animate__animated animate__fadeInDown'>
                              <h1 className='text-white'><span className='text-primary'>Business Centric</span> Solutions</h1>
                              <p>
                                  Empowering business growth with innovative, scalable, and secure technology solutions that accelerate digital transformation, improve operational efficiency, and drive long-term value across cloud, automation, and infrastructure.
                              </p>
                          </div>
                      </div>
                  </div>
                  <div className='row row-gap-3 row-gap-md-5'>
                      <div className='col-sm-6 col-md-4'>
                          <a href='/CloudAutomation'>
                              <div className='product-card wow animate__animated animate__zoomIn'>
                                  <div className='product-icon'>
                                      <img
                                          src="/assets/images/icon1.png"
                                          alt="img"
                                          className="img-fluid"
                                      />
                                  </div>
                                  <div className='product-details'>
                                      <h4 className='text-primary'>Network Implementation</h4>
                                      <p>
                                          End-to-End Network Management including scalability and reliability.
                                      </p>
                                  </div>
                              </div>
                          </a>
                      </div>
                      <div className='col-sm-6 col-md-4'>
                          <div className='product-card wow animate__animated animate__zoomIn'>
                              <div className='product-icon'>
                                  <img
                                      src="/assets/images/icon2.png"
                                      alt="img"
                                      className="img-fluid"
                                  />
                              </div>
                              <div className='product-details'>
                                  <h4 className='text-primary'>Security Solutions</h4>
                                  <p>
                                      Protecting Infrastructure and data, ensuring Regulatory compliance, and Mitigating Risks.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className='col-sm-6 col-md-4'>
                          <div className='product-card wow animate__animated animate__zoomIn'>
                              <div className='product-icon'>
                                  <img
                                      src="/assets/images/icon3.png"
                                      alt="img"
                                      className="img-fluid"
                                  />
                              </div>
                              <div className='product-details'>
                                  <h4 className='text-primary'>Multi-Cloud Services</h4>
                                  <p>
                                      Scalable and secure cloud services for Managed Service Providers.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className='col-sm-6 col-md-4'>
                          <div className='product-card wow animate__animated animate__zoomIn'>
                              <div className='product-icon'>
                                  <img
                                      src="/assets/images/icon4.png"
                                      alt="img"
                                      className="img-fluid"
                                  />

                              </div>
                              <div className='product-details'>
                                  <h4 className='text-primary'>Observability & Infra Automation</h4>
                                  <p>
                                      End to End intelligent monitoring and resolution services & Leverage efficiency through automation.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className='col-sm-6 col-md-4'>
                          <div className='product-card wow animate__animated animate__zoomIn'>
                              <div className='product-icon'>
                                  <img
                                      src="/assets/images/icon5.png"
                                      alt="img"
                                      className="img-fluid"
                                  />
                              </div>
                              <div className='product-details'>
                                  <h4 className='text-primary'>Base Station Services</h4>
                                  <p>
                                      Accelerate deployment through end-to-end services.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className='col-sm-6 col-md-4'>
                          <div className='product-card wow animate__animated animate__zoomIn'>
                              <div className='product-icon'>
                                  <img
                                      src="/assets/images/icon6.png"
                                      alt="img"
                                      className="img-fluid"
                                  />
                              </div>
                              <div className='product-details'>
                                  <h4 className='text-primary'>AI Business Automation</h4>
                                  <p>
                                      Leverage Automation and AI to streamline operations and unlock growth potential.
                                  </p>
                              </div>
                          </div>
                      </div>

                  </div>
              </div>
          </div>*/}
          <div className='delivery-service-section bg-black'>
              <div className='container'>
                  <div className='row'>
                      <div className='col-md-12'>
                          <div className='section-title-div text-center wow animate__animated animate__fadeInDown'>
                              <h1 className='text-white'><span
                                  className='text-primary'>Business Centric</span> Solutions</h1>
                              <p>
                                  Empowering business growth with innovative, scalable, and secure technology solutions
                                  that accelerate digital transformation, improve operational efficiency, and drive
                                  long-term value across cloud, automation, and infrastructure.
                              </p>
                          </div>
                      </div>
                  </div>
                  <div className='delivery-service-list'>
                      <div className='row row-gap-3'>
                          <div className='col-md-12'>
                              <div className='ds-box wow animate__animated animate__fadeInUp'>
                                  <div className='ds-text'>
                                      <h3 className='text-primary'>Network Implementation</h3>
                                      <p>
                                          End-to-End Network Management including scalability and reliability.
                                      </p>
                                  </div>
                                  <div className='ds-icon'>
                                      <img
                                          src="/assets/images/ds-1.png"
                                          alt="img"
                                          className="img-fluid"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div className='col-md-12'>
                              <div className='ds-box wow animate__animated animate__fadeInUp'>
                                  <div className='ds-text'>
                                      <h3 className='text-primary'>Security Solutions</h3>
                                      <p>
                                          Protecting Infrastructure and data, ensuring Regulatory compliance, and Mitigating Risks.
                                      </p>
                                  </div>
                                  <div className='ds-icon'>
                                      <img
                                          src="/assets/images/ds-2.png"
                                          alt="img"
                                          className="img-fluid"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div className='col-md-12'>
                              <div className='ds-box wow animate__animated animate__fadeInUp'>
                                  <div className='ds-text'>
                                      <h3 className='text-primary'>Multi-Cloud Services</h3>
                                      <p>
                                          Scalable and secure cloud services for Managed Service Providers.
                                      </p>
                                  </div>
                                  <div className='ds-icon'>
                                      <img
                                          src="/assets/images/ds-3.png"
                                          alt="img"
                                          className="img-fluid"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div className='col-md-12'>
                              <div className='ds-box wow animate__animated animate__fadeInUp'>
                                  <div className='ds-text'>
                                      <h3 className='text-primary'>Observability & Infra Automation</h3>
                                      <p>
                                          End to End intelligent monitoring and resolution services & Leverage efficiency through automation.
                                      </p>
                                  </div>
                                  <div className='ds-icon'>
                                      <img
                                          src="/assets/images/ds-4.png"
                                          alt="img"
                                          className="img-fluid"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div className='col-md-12'>
                              <div className='ds-box wow animate__animated animate__fadeInUp'>
                                  <div className='ds-text'>
                                      <h3 className='text-primary'>Base Station Services</h3>
                                      <p>
                                          Accelerate deployment through end-to-end services.
                                      </p>
                                  </div>
                                  <div className='ds-icon'>
                                      <img
                                          src="/assets/images/ds-5.png"
                                          alt="img"
                                          className="img-fluid"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div className='col-md-12'>
                              <div className='ds-box wow animate__animated animate__fadeInUp'>
                                  <div className='ds-text'>
                                      <h3 className='text-primary'>AI Business Automation</h3>
                                      <p>
                                          Leverage Automation and AI to streamline operations and unlock growth potential.
                                      </p>
                                  </div>
                                  <div className='ds-icon'>
                                      <img
                                          src="/assets/images/ds-6.png"
                                          alt="img"
                                          className="img-fluid"
                                      />
                                  </div>
                              </div>
                          </div>
                      </div>


                  </div>
              </div>
          </div>

          <div className='why-choose-section bg-black'>
              <div className='container'>
                  <div className='row'>
                      <div className='col-md-7 wow animate__animated animate__fadeInLeft'>
                          <div className='section-title-div'>
                              <h1 className='text-white'><span className='text-primary'>Why Choose</span> Kosmic Lab
                              </h1>
                              <p>
                                  We deliver intelligent, scalable, and secure tech solutions—from cloud to
                                  automation—tailored to your business goals, ensuring performance, innovation, and
                                  long-term growth in a rapidly evolving digital landscape.
                              </p>
                          </div>
                          <div className='choose-box-div'>
                              <div className='choose-box'>
                                  <h3 className='text-primary'>25<small>%</small></h3>
                                  <p className='text-uppercase text-white'>
                                      Deployment Times
                                  </p>
                              </div>
                              <div className='choose-box'>
                                  <h3 className='text-primary'>30<small>%</small></h3>
                                  <p className='text-uppercase text-white'>
                                      Operational Cost
                                  </p>
                              </div>
                              <div className='choose-box border-bottom-0'>
                                  <h3 className='text-primary'>35<small>%</small></h3>
                                  <p className='text-uppercase text-white'>
                                      Incident Response
                                  </p>
                              </div>
                              <div className='choose-box border-bottom-0'>
                                  <h3 className='text-primary'>20<small>%</small></h3>
                                  <p className='text-uppercase text-white'>
                                      Resource Utilization
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className='col-md-5'>
                          <div className='why-choose-img wow animate__animated animate__fadeInRight'>
                              <img
                                  src="/assets/images/choose-img.png"
                                  alt="img"
                                  className="img-fluid"
                              />
                          </div>
                      </div>
                  </div>
              </div>
          </div>


          <div className='customer-loveus-section bg-black overflow-hidden'>
              <div className='row align-items-center'>
                  <div className='col-md-4'>
                      <div className='cls-img wow animate__animated animate__fadeInLeft'>
                          <img
                              src="/assets/images/customer-img.png"
                              alt="img"
                              className="img-fluid w-auto"
                          />
                      </div>
                  </div>
                  <div className='col-md-8'>
                      <div className='cls-slider wow animate__animated animate__fadeInRight'>
                          <div className='section-title-div'>
                              <h1 className='text-white'><span className='text-primary'>Customers</span> love us
                              </h1>
                          </div>
                          <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">

                              <div className="carousel-inner">
                                  <div className="carousel-item active">
                                      <div className='cls-content'>
                                          <p className='text-white'>
                                              “From network setup to observability, Kosmic Lab handled everything flawlessly. Their expertise in multi-cloud and infrastructure automation is unmatched—we’ve never felt more confident in our digital systems. Their layered approach and constant monitoring gave us the peace of mind we needed.”
                                          </p>
                                          <div className='cls-detail'>
                                              <h5 className='text-primary'>Erica Jordon</h5>
                                              <small>CEO, Apollo</small>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="carousel-item">
                                      <div className='cls-content'>
                                          <p className='text-white'>
                                              “From network setup to observability, Kosmic Lab handled everything
                                              flawlessly. Their expertise in multi-cloud and infrastructure automation
                                              is unmatched—we’ve never felt more confident in our digital systems. Their
                                              layered approach and constant monitoring gave us the peace of mind we
                                              needed.”
                                          </p>
                                          <div className='cls-detail'>
                                              <h5 className='text-primary'>Erica Jordon</h5>
                                              <small>CEO, Apollo</small>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="carousel-item">
                                      <div className='cls-content'>
                                          <p className='text-white'>
                                              “From network setup to observability, Kosmic Lab handled everything
                                              flawlessly. Their expertise in multi-cloud and infrastructure automation
                                              is unmatched—we’ve never felt more confident in our digital systems. Their
                                              layered approach and constant monitoring gave us the peace of mind we
                                              needed.”
                                          </p>
                                          <div className='cls-detail'>
                                              <h5 className='text-primary'>Erica Jordon</h5>
                                              <small>CEO, Apollo</small>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div className="carousel-indicators">
                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
                                          className="active" aria-current="true" aria-label="Slide 1"></button>
                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                                          aria-label="Slide 2"></button>
                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                                          aria-label="Slide 3"></button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className='news-section'>
              <div className='container'>
                  <div className='section-title-div'>
                      <div className='row align-items-center'>
                          <div className='col-md-8'>
                              <h1 className='text-capitalize wow animate__animated animate__fadeInLeft'>
                                  Insights from experts<br/>
                                  & <span className='text-primary'>news</span> from the industry
                              </h1>

                          </div>
                          <div className='col-md-4'>
                              <div className='sec-btn justify-content-end  wow animate__animated animate__fadeInRight'>
                                  <a href='#' className='btn btn-dark'>
                                      View all blogs
                                  </a>
                              </div>
                          </div>
                      </div>
                  </div>


                  <div className='row row-gap-3'>
                      <div className='col-md-6'>
                          <div className='news-card  wow animate__animated animate__zoomIn'>
                              <img
                                  src="/assets/images/news-1.png"
                                  alt="news"
                                  className="img-fluid w-100"
                              />
                              <h3>Boost Business Efficiency
                                  with AI Automation Today</h3>
                          </div>
                      </div>
                      <div className='col-md-6'>
                          <div className='news-card wow animate__animated animate__zoomIn'>
                              <img
                                  src="/assets/images/news-2.png"
                                  alt="news"
                                  className="img-fluid w-100"
                              />
                              <h3>Why Multi-Cloud Strategy
                                  Matters for Modern Enterprises</h3>
                          </div>
                      </div>
                  </div>

              </div>
          </div>


      </div>
  );
};

export default Home;
